import { render } from "./DetailButtons.vue?vue&type=template&id=8113d4c0"
import script from "./DetailButtons.vue?vue&type=script&lang=ts"
export * from "./DetailButtons.vue?vue&type=script&lang=ts"

import "./DetailButtons.vue?vue&type=style&index=0&id=8113d4c0&lang=scss"
script.render = render

export default script